export { default } from "./ExpandingContent";
